import { EnvioRda, EmpresaAuditora } from ".";
import { Moment } from "moment";

export class RelatorioConclusivo {

  id: number;
  envioRda: EnvioRda;
  empresaAuditora: EmpresaAuditora;
  idUnicoPessoaEnvio: number;
  idMomentoPessoaEnvio: number;
  dataEnvio: Moment;
  cdRecibo: string;
  caminhoArquivoRelatorio: string;
  caminhoArquivoRecibo: string;

  constructor(init?: Partial<RelatorioConclusivo>) {
    Object.assign(this, init);
  }
}
